import { createContext, useContext } from "react";
import { useWhitelist } from "../hooks/useWhitelist";
const Context = createContext();

export const WhitelistProvider = ({ children }) => {
  return (
    <Context.Provider value={useWhitelist()}>{children}</Context.Provider>
  );
};

export const useWhitelistContext = () => useContext(Context);
